import React from "react";
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../../store/userContextStore';
import { hasPermission } from '../../store/apiWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { skins } from '../../store/displaySettingsStore';
import classnames from 'classnames';

import './settings.scss';

class DisplaySettings extends React.Component {
    constructor(props) {
        super(props);
    }

    _settings = [
        {
            header: 'Settings.Display.ReportHeaders',
            value: { '1': 'round', '2': 'square' },
            label: {
                '1': 'Settings.Display.Round',
                '2': 'Settings.Display.Square'
            },
            name: 'reportHeadersStyle',
            localStorageName: 'locales_report_headers_style',
            tab: "style"
        },
        {
            header: 'Settings.Display.MenuActive',
            value: { '1': 'round', '2': 'square' },
            label: {
                '1': 'Settings.Display.Round',
                '2': 'Settings.Display.Square'
            },
            name: 'menuActiveStyle',
            localStorageName: 'locales_menu_active_style',
            tab: "style"
        },
        {
            header: 'Settings.Display.ButtonsStyle',
            value: { '1': 'round', '2': 'square' },
            label: {
                '1': 'Settings.Display.Round',
                '2': 'Settings.Display.Square'
            },
            name: 'buttonStyle',
            localStorageName: 'locales_button_style',
            tab: "style"
        },
        {
            header: 'Settings.Display.PopupHeaders',
            value: { '1': 'filled', '2': 'standard' },
            label: {
                '1': 'Settings.Display.Popup.Tint',
                '2': 'Settings.Display.Popup.None'
            },
            name: 'popupHeaderStyle',
            localStorageName: 'locales_popup_header_style',
            tab: "style"
        },
        {
            header: 'Settings.Display.MenuColorization',
            value: { '1': 'menu', '2': 'header', '3': 'none' },
            name: 'tint',
            localStorageName: 'locales_tint',
            label: {
                '1': 'Settings.Display.MenuColorization.Menu',
                '2': 'Settings.Display.MenuColorization.Header',
                '3': 'Settings.Display.MenuColorization.None'
            },
            tab: "general"
        },
        {
            header: 'Settings.Display.FontSize',
            value: { '1': '12px', '2': '14px', '3': '16px' },
            name: 'fontSize',
            localStorageName: 'font_size',
            label: {
                '1': 'Settings.Display.FontSize.Small',
                '2': 'Settings.Display.FontSize.Medium',
                '3': 'Settings.Display.FontSize.Large'
            },
            tab: "general"
        },
        {
            header: 'Settings.Display.Font',
            value: { '1': 'montserrat', '2': 'open-sans' },
            name: 'font',
            localStorageName: 'font',
            label: {
                '1': 'Settings.Display.Font.Default',
                '2': 'Settings.Display.Font.Originals'
            },
            tab: "general"
        },
        {
            header: 'Settings.Display.UrlFormat',
            value: { '1': 'underline', '2': 'normal' },
            name: 'urlFormat',
            localStorageName: 'locales_url_format',
            label: {
                '1': 'Settings.Display.UrlFormat.Underline',
                '2': 'Settings.Display.UrlFormat.Normal'
            },
            tab: "general"
        },
        {
            header: 'Settings.Display.ReportWidth',
            value: { '1': 'fixed', '2': 'full' },
            name: 'reportWidth',
            localStorageName: 'locales_report_width',
            label: {
                '1': 'Settings.Display.ReportWidth.Fixed',
                '2': 'Settings.Display.ReportWidth.Full'
            },
            tab: "general"
        },
        {
            header: 'Settings.Display.ReportButtonsFormat',
            value: { '1': 'full', '2': 'short' },
            name: 'reportButtonsFormat',
            localStorageName: 'locales_report_buttons_format',
            label: {
                '1': 'Settings.Display.ReportButtonsFormat.FullName',
                '2': 'Settings.Display.ReportButtonsFormat.Abbreviation'
            },
            tab: "general"
        }
    ]

    getGradientColor(code) {
        switch (code) {
            case "blue":
                return "linear-gradient(90deg, #013670 0%, #01488a 50%, #0b809e 100%)";
            case "red":
                return "linear-gradient(90deg, #ae7199, #e74360, #f08635)";
            case "dark":
                return "linear-gradient(135deg, #00c59e 0%, #047c64 100%)";
            default:
                return "#fff";
        }
    }

    render() {
        var themes= [];
        themes = themes.concat(skins);
        return (
            <div className="settings-page-wrapper">
                {this.props.tab === "general" && <div className="settings-item">
                    <div className="bold">{this.props.translate("Settings.Display.Theme")}</div>
                    <div className="columns">
                        <div className="column" style={{ display: "flex", paddingLeft: '1.75em' }}>
                            {themes.map(x => (
                                <span key={x.code} className="style-loader-item" onClick={() => { this.changeSetting('theme', 'locales_theme', x.code); }}>
                                    <div className="theme-item" style={{ background: this.getGradientColor(x.code) }}>
                                        <div className="theme-item" style={{ background: `linear-gradient( 315deg, ${x.color} 50%, transparent 50% )` }}>
                                            {x.code === this.props.authentication.profile.displaySettings.theme &&
                                                <div className="theme-item-check">
                                                    <FontAwesomeIcon icon="check"></FontAwesomeIcon>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>}
                {
                    this._settings.map(i => (<React.Fragment key={i.header}>
                        {this.props.tab === i.tab &&<div className='settings-item'>
                            <div className="bold">{this.props.translate(i.header)}</div>
                            <div className="settings-row">
                                <div className="settings-selector" style={{ paddingBottom: '10px' }}>
                                    {
                                        Object.keys(i.value).map(j => (
                                            <span key={j} data-active={i.value[j] === this.props.authentication.profile.displaySettings[i.name]}
                                                onClick={() => this.changeSetting(i.name, i.localStorageName, i.value[j])}>{i.label ? this.props.translate(i.label[j]) : ""}</span>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>}
                    </React.Fragment>))
                }
                <hr className='settings-divider' />
                <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })} 
                    style={{ fontWeight: 600 }} onClick={() => this.props.resetDisplaySettings()}>{this.props.translate("Common.Restore.Default.DisplaySettings")}</span>
                <br /> {/* br must be here otherwise buttons are not accessible on apple devices (stupid Safari) */}
            </div >
        )
    }

    componentDidUpdate(prevProps, prevState) {
        const changed = this.checkChanges(this.props.authentication.profile.displaySettings, prevProps.authentication.profile.displaySettings);
        if (Object.keys(changed).length > 0)
            this.props.syncSettings(changed);
    }

    checkChanges(now, before) {
        let changed = {};
        const keys = Object.keys(now);
        for (let idx = 0; idx < keys.length; idx++) {
            if(now[keys[idx]] !== before[keys[idx]]) {
                changed[keys[idx]] = now[keys[idx]];
            }
        }
        return changed;
    }

    changeSetting = (key, storageKey, value) => {
        this.props.updateDisplaySettings(key, storageKey, value);
    }
}

export default withRouter(withLocalize(connect(
    state => state.userContext,
    dispatch => bindActionCreators(userContextActions, dispatch)
)(DisplaySettings)));